import { styled } from 'theme'
import { Flex } from 'components/elements'

export const SvgCircleWrap = styled(Flex, {
  p: '$space$8',
  borderRadius: '$radii$rounded',
  zIndex: 1,

  variants: {
    color: {
      primary: {
        background: '$primaryBgSubtle',
        borderColor: '$primary50',
        svg: {
          path: {
            stroke: '$primaryBase',
          },
        },
      },
      secondary: {},
      gray: {},
      warning: {
        background: '$warningBg',
        borderColor: '$warning50',
        svg: {
          path: {
            stroke: '$warning',
          },
        },
      },
      error: {
        background: '$errorBg',
        borderColor: '$error50',
        svg: {
          path: {
            stroke: '$error',
          },
        },
      },
      success: {
        background: '$successBg',
        borderColor: '$success50',
        svg: {
          path: {
            stroke: '$success',
          },
        },
      },
      transparent: {},
      black: {},
      white: {
        background: '$whiteBase',
        borderColor: '#0ACC06',
        svg: {
          path: {
            stroke: '#0ACC06',
          },
        },
      },
      darkGray: {},
      disabled: {},
    },
  },
  defaultVariants: {
    color: 'primary',
  },
})

export const GroupIconCss = {
  'borderWidth': 4,
  'p': '$space$5',
  'borderStyle': 'solid',
  'borderRadius': '$radii$rounded',
  '@media(min-width: 600px)': {
    borderWidth: 6,
    p: '$space$6',
  },
}
